export const FREIGHT_REQUESTS_FETCHED = 'FREIGHT_REQUESTS_FETCHED';
export const FREIGHT_REQUESTS_CLEARED = 'FREIGHT_REQUESTS_CLEARED';

export const FREIGHT_REQUEST_FETCHED = 'FREIGHT_REQUEST_FETCHED';

export const FREIGHT_REQUEST_LOCATIONS_FETCHED = 'FREIGHT_REQUEST_LOCATIONS_FETCHED';
export const FREIGHT_REQUEST_CAPACITIES_FETCHED = 'FREIGHT_REQUEST_CAPACITIES_FETCHED';
export const FREIGHT_REQUEST_DISPLAYS_FETCHED = 'FREIGHT_REQUEST_DISPLAYS_FETCHED';
export const FREIGHT_REQUEST_PARTNERS_FETCHED = 'FREIGHT_REQUEST_PARTNERS_FETCHED';
